import { memo } from "react";

import PanelActionBarComponent from "../../../common/PanelActionBarComponent";
// import ContactPanel from "../../../common/ContactPanel";
import InformationPanel from "../../../common/InformationPanel";
// import NotesPanel from "../../../NotesPanelSection/NotesPanel";
import DocumentRow from "../../../DocumentRow/DocumentRow";
import InsuranceIcon from "../../../../../public/BP_resources/images/icon/insurance-icon-color.svg";
// import { getFullName } from "../../helpers/helpers";
import ContactPanelForTreatment from "../../../TreatmentPage/components/ContactPanelForTreatment";
import TreatmentNotesSection from "../../../TreatmentPage/NotesTreatmentSection";
import "../../../common/RecordPanel.css";

import { InsuranceButtons, LienButtonsConfig, PANEL_TYPES } from "./constants/insuranceConfig";
import {
  formatClaimInformation,
  formatLienInformation,
  getContactData,
} from "./utils/insuranceDataHelpers";

const InsuranceCard = memo(({ insurance, billData, onEdit, onExtractData, name = "", avatar }) => {
  const handlePanelClick = (panelType) => {
    onExtractData(insurance);
    onEdit(panelType);
  };

  const claimInfo = formatClaimInformation(insurance);
  const lienInfo = formatLienInformation(insurance, billData);

  const insuranceConfig = [
    {
      id: "generate-document-button",
      // iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      buttonText: "Active on Incident Date ",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {},
      onMouseLeave: () => {},
      onClick: () => {},
    },
  ];

  const insuranceConfig2 = [
    {
      id: "generate-document-button",
      // iconClassName: "ic ic-19 ic-avatar has-avatar-icon has-cover-img m-l-5",
      buttonText: "Final Lien: $99,999.99",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {},
      onMouseLeave: () => {},
      onClick: () => {},
    },
  ];

  return (
    <div className="report record-panel" style={{ position: "relative" }}>
      <PanelActionBarComponent
        compact
        panelIconSrc={InsuranceIcon}
        instanceForName={insurance?.insurance_type?.name}
        page_id={11}
        type={insurance?.insurance_type?.name}
        id={insurance?.id}
        name={name}
        forInstanceName={name}
        avatar={avatar}
        hasClientPageInsuranceIcon={true}
        iconClassName="insurance"
      />

      <div className="record-panel-body d-flex flex-wrap" style={{ gap: "5px" }}>
        <div
          className="leins-container-six m-b-5"
          style={{
            gap: "5px",
          }}
        >
          {/* Company Contact */}
          <ContactSection
            panelName="Insurance Company"
            type={PANEL_TYPES.COMPANY}
            insurance={insurance}
            onPanelClick={handlePanelClick}
            buttonConfig={InsuranceButtons}
            contactKey="company_contact"
            genrate_doc_address={11}
            templateDropdownId={11}
            templatePageId={11}
          />

          {/* Adjuster Contact */}
          <ContactSection
            panelName="Adjuster"
            type={PANEL_TYPES.ADJUSTER}
            insurance={insurance}
            onPanelClick={handlePanelClick}
            buttonConfig={InsuranceButtons}
            contactKey="adjuster"
            genrate_doc_address={12}
            templateDropdownId={12}
            templatePageId={11}
          />

          {/* Supervisor Contact */}
          <ContactSection
            panelName="Supervisor"
            type={PANEL_TYPES.SUPERVISOR}
            insurance={insurance}
            onPanelClick={handlePanelClick}
            buttonConfig={InsuranceButtons}
            contactKey="supervisor"
            genrate_doc_address={13}
            templateDropdownId={13}
            templatePageId={11}
          />

          {/* Claim Information */}
          <InformationSection
            type={PANEL_TYPES.CLAIM}
            title="Claim Information"
            data={claimInfo}
            onPanelClick={handlePanelClick}
            buttonConfig={insuranceConfig}
            hasBtn={true}
            defaultValue={5}
          />

          {/* Lien Holder Contact */}
          <ContactSection2
            type={PANEL_TYPES.LIEN}
            insurance={insurance}
            onPanelClick={handlePanelClick}
            buttonConfig={LienButtonsConfig}
            contactKey="lien_adjuster"
            panelName="Lien Adjuster"
            genrate_doc_address={0}
            templateDropdownId={0}
            templatePageId={11}
          />
          {/* Lien Information */}
          <InformationSection
            type={PANEL_TYPES.LIEN_ADJUSTER}
            title="Lien Information"
            data={lienInfo}
            onPanelClick={handlePanelClick}
            hasBtn={true}
            buttonConfig={insuranceConfig2}
            defaultValue={5}
          />
        </div>
        <div
          className=""
          style={{
            flex: 1,
            minWidth: "min(400px, 100%)",
            // minHeight: "160px",
            paddingRight: "0px",
            scrollbarWidth: "none",
          }}
        >
          <p className="menu-bar-style columnsTitle text-center">Notes</p>
          <TreatmentNotesSection
            record_id={insurance.id}
            instanceFor="Insurance"
            module="Insurance2"
            notesName="Insurance"
            pagePanels={6}
            // module={"Insurance"}
          />
          {/* <div
          style={{
            marginTop: "-5px",
            flex: 1,
            height: "calc(100% - 65px)",
          }}
        >
          <NotesSection insurance={insurance} /> */}
        </div>
      </div>

      <DocumentSection insurance={insurance} />
    </div>
  );
});

const ContactSection = memo(
  ({
    type,
    insurance,
    onPanelClick,
    buttonConfig,
    contactKey = type,
    panelName = type.charAt(0).toUpperCase() + type.slice(1),
    genrate_doc_address,
    templateDropdownId,
    templatePageId,
  }) => {
    const contact = insurance[contactKey];
    const contactData = getContactData(contact, type);
    return (
      <div
        className=""
        style={{
          maxHeight: "155px",
        }}
      >
        <ContactPanelForTreatment
          panel_name={panelName}
          className="m-b-0"
          dynamic_label="Company Name"
          onSelectObject={() => onPanelClick(type)}
          buttonData={buttonConfig}
          pageName="Case Loans"
          genrate_doc_address={genrate_doc_address}
          templateDropdownId={templateDropdownId}
          templatePageId={templatePageId}
          {...contactData}
        />
      </div>
    );
  }
);

const ContactSection2 = memo(
  ({
    type,
    insurance,
    onPanelClick,
    buttonConfig,
    contactKey = type,
    panelName = type.charAt(0).toUpperCase() + type.slice(1),
    genrate_doc_address,
    templateDropdownId,
    templatePageId,
  }) => {
    const contact = insurance[contactKey]?.contact;
    const contactData = getContactData(contact, type);

    return (
      <div
        className=""
        style={{
          maxHeight: "155px",
        }}
      >
        <ContactPanelForTreatment
          panel_name={panelName}
          className="m-b-0"
          dynamic_label="Company Name"
          onSelectObject={() => onPanelClick(type)}
          buttonData={buttonConfig}
          pageName="Case Loans"
          genrate_doc_address={genrate_doc_address}
          templateDropdownId={templateDropdownId}
          templatePageId={templatePageId}
          {...contactData}
        />
      </div>
    );
  }
);

const InformationSection = memo(({ type, title, data, onPanelClick, buttonConfig, hasBtn }) => (
  <div
    className="liens-container-item"
    style={{
      maxHeight: "155px",
    }}
  >
    <InformationPanel
      panel_name={title}
      className="m-b-5"
      labelClassName="font-weight-600"
      valueStyle={{
        maxWidth: "70%",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
        overflow: "hidden",
        // color: "var(--primary-25)",
      }}
      labelStyle={{ color: "var(--primary-25)" }}
      data={data}
      onSelectReport={() => onPanelClick(type)}
      buttonData={hasBtn ? buttonConfig : []}
      hasBtn={hasBtn}
      {...(hasBtn && { defaultLength: 5 })}
    />
  </div>
));

// const NotesSection = memo(({ insurance }) => (
//   <div
//     className="d-flex d-flex-1 p-t-5 p-l-5 m-b-5 overflow-hidden"
//     style={{
//       height: "calc(100% - 65px)",
//     }}
//   >
//     <NotesPanel
//       record_id={insurance.id}
//       instanceFor="Insurance"
//       module="Insurance"
//       notesName="Insurance"
//       pagePanels={6}
//     />
//   </div>
// ));

const DocumentSection = memo(({ insurance }) => (
  <div className="d-flex">
    <div className="col-12">
      {/* <div className="height-25">
        <h4 className="text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case background-main-10 font-weight-semibold text-center client-contact-title">
          &nbsp;Document Row
        </h4>
      </div> */}
      <DocumentRow
        clientProvider={insurance}
        page_id={11}
        showLabel={false}
        showSaveToPage={false}
      />
    </div>
  </div>
));

export default InsuranceCard;
